import { ColumnLayout } from "@mittwald/flow-remote-react-components";
import { Skeleton } from "@mittwald/flow-remote-react-components";

export const AppInstallationPHPSettingsSkeleton = () => {
  return (
    <>
      <Skeleton height="40px" />
      <ColumnLayout rowGap="l" columnGap="l" m={[1, 1]}>
        <Skeleton height="40px" />
        <Skeleton height="40px" />
      </ColumnLayout>
      <Skeleton height="40px" />
      <Skeleton height="40px" />
      <ColumnLayout rowGap="l" columnGap="l">
        <Skeleton height="40px" />
        <Skeleton height="40px" />
        <Skeleton height="40px" />
      </ColumnLayout>
      <Skeleton height="40px" />
      <ColumnLayout rowGap="l" columnGap="l" m={[1, 1]}>
        <Skeleton height="40px" />
        <Skeleton height="40px" />
      </ColumnLayout>
      <Skeleton height="40px" />
      <Skeleton height="40px" />
      <ColumnLayout rowGap="l" columnGap="l">
        <Skeleton height="40px" />
        <Skeleton height="40px" />
        <Skeleton height="40px" />
      </ColumnLayout>
    </>
  );
};
